module.exports = __webpack_public_path__ + "media/new_alert.c56fad40.mp3";